import {clearSelection} from '../reducers';

import {
    selectionSelector,
    selectVisibility,
    visibilityStateSelector,
} from '../selectors';

import {
    useAppDispatch,
    useAppSelector
} from '../../../../hooks/useTypedReactRedux';

import {
    useApplicationsQuery,
    useDeleteApplicationMutation,
} from './useApplicationsQuery';

// FNP-947: records come from React Query; selection stays in Redux. Return
// shape unchanged so the table, buttons and inputs consuming this hook did not
// change.
export const useApplications = () => {

    const dispatch = useAppDispatch();

    const selection = useAppSelector((state) => selectionSelector(state));
    const visibility = useAppSelector((state) => visibilityStateSelector(state));

    const {
        data,
        isLoading,
        refetch
    } = useApplicationsQuery();

    const deleteMutation = useDeleteApplicationMutation();

    const {
        items,
        visibleItems,
    } = selectVisibility(visibility, data ?? []);

    // FETCH
    const fetchRecords = () => {
        refetch();
    };

    const deleteRecords = () => {
        if (Object.keys(selection).length > 0) {
            for (const key in selection) {
                deleteMutation.mutate(key);
            }
            // Clear the checkboxes once the deletions are issued - otherwise the
            // selection keeps naming records that no longer exist.
            dispatch(clearSelection());
        }
    };


    return {
        items,
        visibleItems,
        loading: isLoading,
        fetchRecords,
        deleteRecords,
    };
};
